import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import logo from '../../assets/snb_ic.png';
import AndroidLogo from '../../assets/android-snb-app.png';
import IosLogo from '../../assets/apple-snb-app.png';
import faceBook from '../../assets/icon-facebook.jpg';
import Instagram from '../../assets/icon-instagram.jpg';
import Youtube from '../../assets/icon-youtube.jpg';

function ThankYouPage() {
    return (
        <div className="card Card-container" style={{ background: 'white' }}>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                    <div className="">
                        <div className="card-body" style={{ padding: '20px 0px' }}>
                            <div className="row ThemeBorder">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <img src={logo} className="Header-img" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="login-container-width background">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 alignCen slogenText" style={{ margin: '20px 0px 5px' }}>
                        <div className="card-text Fw F1 alignCen thnkTxt">Thank You..</div>
                    </div>
                </div>

                <div className="row Mb-2">
                    <div className="card-body card-Pd">
                        <div className="col-sm-12 col-md-12 col-lg-12 card-text Fw F2" style={{ textAlign: 'justify' }}>
                            You have reduce your friend maintainence,if you want to get reward then download The Society Maintainence App
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="card-body card-Pd">
                        <div className="card-text Fw F1 alignCen">Quick Download</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 card-text Fw F3 alignCen">Android & Apple App</div>
                </div>

                <div className="row alignCen" style={{ margin: '25px 0px 40px' }}>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                        <img src={AndroidLogo} width="75%" alt="" />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                        <img src={IosLogo} width="75%" alt="" />
                    </div>
                </div>

                <table className="BuyBtnFooter" style={{ textAlign: 'center', width: '100%' }}>
                    <tbody>
                        <tr style={{ background: '#f44134' }}>
                            <td align="center">
                                <table width="250" cellPadding="0" cellSpacing="0" style={{ background: '#f44134' }}>
                                    <tbody>
                                        <tr className="alignCen">
                                            <td style={{ padding: '5px' }}>
                                                <a href="https://www.facebook.com/SocietyNotebook" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                                    <img src={faceBook} height="30px" alt="" />
                                                </a>
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                <a href="https://www.instagram.com/society_notebook/" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                                    <img src={Instagram} height="30px" alt="" />
                                                </a>
                                            </td>
                                            <td style={{ padding: '5px' }}>
                                                <a
                                                    href="https://www.youtube.com/playlist?list=PLOwmrLliIOIiPdLdcp5eSSoxi4Uv-U7XH"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <img src={Youtube} height="30px" alt="" />
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const mapStateToProps = () => ({});

export default compose(connect(mapStateToProps), withRouter)(ThankYouPage);
